@if (model && model.data) {
<href [link]="model.data.url">
    <div class="w-12 p-a p-a-2-m p-a-2-s flex overflow-hidden hotspot-content">

        @if (hotspot().productImage && model.data.image) {
        <img class="w-12 hotspot-image"
             [dfImage]="model.data.image">
        }

        <div class="w-12 flex-column flex-justify-between"
             [class.m-l-2]="hotspot().productImage && model.data.image">
            <div class="w-12 flex-grow p2">

                @if (model.canDisplayReviews) {
                <reviews-io-rating class="m-b-1"
                                   [product]="model" />
                }

                @if(rangeDescription) {
                <p class="s2"
                   [style.font-weight]="700">
                    {{rangeDescription}}

                </p>
                }

                <p class="s2 col-1">
                    {{model.data.product_outline}}
                </p>

                @if (hotspot().productPrice) {
                <div class="w-12 m-t-1 flex flex-middle">
                    @if (hotspot().productPrice) {
                    @if (model.orgPrice) {
                    <price class="m-r-2 line-through col-12 p2"
                           [style.font-weight]="500"
                           [value]="model.orgPrice" />
                    }
                    <price class="m-r-1 p2"
                           [class.col-2]="model.orgPrice"
                           [style.font-weight]="500"
                           [value]="model.price" />
                    }
                </div>
                }
            </div>

            <button class="w-6 w-8-m w-8-s p-a-0 button"
                    [style.height.px]="34"
                    type="button">
                <span class="c1 no-wrap"
                      [style.line-height.px]="34">
                    {{'View Product' | translate}}
                </span>
            </button>
        </div>
    </div>
</href>
}
